import React from 'react'

const Company = ({ data }: any) => {
  const { entityDetails } = data()
  return (
    <>
      <div className="mt-4 text-left text-2xl font-semibold">Company Details</div>
      <div className="mt-6">
        <div className="flex w-full justify-between">
          <div className="w-1/2">
            <h3 className="mb-2 text-lg font-medium uppercase">Basic Information</h3>
            <div className="pl-2">
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Email:</span>
                {entityDetails.email}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Name:</span>
                {entityDetails.companyName}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">EIN:</span>
                {entityDetails.ein}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Phone Number:</span>
                {entityDetails.phoneNumber}
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <h3 className="mb-2 text-lg font-medium uppercase">Address Information</h3>
            <div className="pl-2">
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Country:</span>
                {entityDetails.addressInfo.country}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">State:</span>
                {entityDetails.addressInfo.state}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Street Line 1:</span>
                {entityDetails.addressInfo.Street1}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Street Line 2:</span>
                {entityDetails.addressInfo.Street2}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">City:</span>
                {entityDetails.addressInfo.city}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Postal Code:</span>
                {entityDetails.addressInfo.postalCode}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Company
